/**
 * Poll a background job until it finishes.
 *
 * `onPending` is called with the job's reported progress on every poll that comes
 * back still pending, so a long job can show something better than a spinner.
 * Jobs that report no progress simply never call it.
 */
export async function pollJobStatus(
  getStatusFn,
  { interval = 3000, timeout = 7 * 60 * 1000, onPending = null } = {},
) {
  const startTime = Date.now();
  while (true) { // eslint-disable-line no-constant-condition
    if (Date.now() - startTime > timeout) return { status: 'timeout' };
    await new Promise(resolve => setTimeout(resolve, interval));
    const { status, result, progress } = (await getStatusFn()).data;
    if (status !== 'pending') return { status, result };
    if (onPending && progress) onPending(progress);
  }
}
